const constants = {
  contract: {
    accrualType: {
      not_determined: 'Не определен',
      regular_fixed_charges: 'Регулярные фиксированные начисления',
      in_agreement_with_decision_maker: 'Начисления по согласованию с ЛПР',
      when_approaching_zero_balance: 'Начисления при приближении к нулевом балансу (без согласования с ЛПР)',
    },
    accrualTypeComment: {
      regular_fixed_charges: `• Начисления производятся один раз в неделю(/месяц/квартал/год). Начисляться может как определенный пакет уроков (например, +8 уроков), так и произвольное кол-во уроков до определенного значения баланса (например, +n уроков до баланса в 8 уроков).
• В поле "Комментарий к порядку начисления уроков" укажите как часто и сколько уроков необходимо начислять`,
      in_agreement_with_decision_maker: `• Начисления инициирует ЛПР или КАМ. При таком типе начислений отсутствуют фиксированные еже-недельные/месячные/квартальные пополнения и решение о начислении принимает ЛПР.
• Поле "Комментарий к порядку начисления уроков" заполняется в свободной форме, но если есть подробности или нюансы, касающиеся начислений текущим студентам, обязательно укажите их.`,
      when_approaching_zero_balance: `• Начисления инициирует МС. Это вид начислений, когда мы без согласования с ЛПР начисляем уроки всем ученикам, у которых низкий баланс.
• В поле "Комментарий к порядку начисления уроков" укажите какой пакет уроков необходимо начислять при низком балансе.`,
    },
    paymentTypePrePostPay: {
      prepay: 'Предоплата',
      postpay: 'Постоплата',
    },
    managerType: {
      salesManager: 'МП',
      keyAccountManager: 'KAM',
    },
    paymentType: {
      prepay: 'Предоплата',
      postpay: 'Постоплата',
      partial_pay: 'ЧК',
      special_offer: 'Спецпредложение',
      corporate_special_offer: 'Спецпредложение (корп)',
    },
    stage: {
      accounting: 'Аккаунтинг',
      support: 'Поддержка',
      before_call: 'Ждёт звонка',
      after_call: 'Ждет вводного урока',
      after_trial: 'Был вводный урок',
      regular_lessons: 'Регулярные занятия',
      lost: 'Ученик потерян',
      vacation: 'Ученик в отпуске',
    },
    state: {
      active: 'Активный',
      not_active: 'Неактивный',
      not_activated: 'Неактивированный',
    },
    firstPaymentBy: {
      person: 'Клиент',
      company: 'Компания',
    },
    contractor: {
      langin_acc: 'ООО «Языковые Инновации»',
      ano_acc: 'ОАНО ДПО «Скаенг»',
      ot_acc: 'ООО «Образовательные технологии»',
      langroom: 'Лэнгрум',
      agaton: 'Агатон',
    },
  },
};

export default constants;
